import React from "react";
import { motion } from "framer-motion";
import girl from "../images/g1.png";


const Hero = () => {
  const variants = {
    hidden: { opacity: 0, y: 75 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <>
      <div className=" w-full " >
        <div className=" md:flex md:justify-between md:items-center  lg:px-20 md:pt-32 pt-10 lg:mx-5 md:mx-10">
          {/* writng */}
        <div  className="md:w-1/2 md:text-left ">
          <motion.div
            initial="hidden"
            animate="visible"
            exit="hidden"
            transition={{ duration: 0.8 }}
            variants={variants}
          >
            <section>
              <FlipText>ANSA &nbsp; ALI</FlipText>
            </section>
            <p className="text-[#39ffde] uppercase md:text-xl text-sm md:mb-5 mb-2 md:leading-[0.99px] lg:tracking-[5px] text-center md:text-left md:mx-5" >
              MERN Stack Developer
            </p>
        
            <p className="font-thin text-sm md:text-xl font-body text-[#ffffff] mb-5 text-center md:text-left px-5 ">
              I'm a dedicated MERN stack developer with a strong foundation in
              full-stack applications and a passion for enhancing user
              experiences through UX/UI design. As an artist and content creator
              on YouTube and Instagram, I enjoy sharing my art and craft
              projects.
            </p>
          </motion.div>
        </div>
        {/* image */}
        <div className="md:right-0  ">
          <img src={girl} alt="Ansa" className="md:w-80 lg:w-96 h-auto w-56 m-auto " />
        </div>
        </div>
      </div>

      {/* <Skills /> */}
    </>
  );
};

const DURATION = 0.999;
const STAGGER = 0.1;

const FlipText = ({ children }) => {
  return (
    <motion.h1
      initial="initial"
      whileHover="hovered"
      className=" block overflow-hidden whitespace-nowrap font-thin lg:text-6xl md:mb-5 mb-2 text-3xl lg:tracking-[10px] text-center md:mx-5 md:text-left"
     
    >
      <div className="inline-block">
        {children.split("").map((letter, index) => {
          return (
            <motion.span
              key={index}
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              transition={{
                duration: DURATION,
                ease: "easeInOut",
                delay: STAGGER * 2 * index,
              }}
              className="inline-block text-[#00FFD3]" // Single color for both names
            >
              {letter}
            </motion.span>
          );
        })}
      </div>
    </motion.h1>
  );
};

export default Hero;
